import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Link } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { locationPriceSuffix } from '../utils/listingPrice';
import './ListingsMap.css';

// Fix icônes Leaflet cassées dans CRA
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const COULEURS = {
  'location':    '#1a73e8',
  'vente-maison':'#16a34a',
  'terrain':     '#f59e0b',
};
const LABELS = {
  'location':    'Location',
  'vente-maison':'Vente',
  'terrain':     'Terrain',
};

function creerIcone(type) {
  const couleur = COULEURS[type] || '#64748b';
  return L.divIcon({
    className: '',
    html: `<div class="map-marker" style="background:${couleur}">
             <div class="map-marker-inner"></div>
           </div>`,
    iconSize: [28, 36],
    iconAnchor: [14, 36],
    popupAnchor: [0, -38],
  });
}

const fmt = (n) => new Intl.NumberFormat('fr-GN', { maximumFractionDigits: 0 }).format(n) + ' GNF';

export default function ListingsMap({ annonces }) {
  const avecGps = annonces.filter(a => a.latitude && a.longitude);

  useEffect(() => {
    // Invalider la taille de la carte après le rendu (sinon tuiles vides)
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }, []);

  if (avecGps.length === 0) {
    return (
      <div className="map-vide">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
        <p>Aucune annonce avec localisation GPS dans cette sélection.</p>
        <small>Les propriétaires peuvent ajouter un lien Google Maps lors de la création de leur annonce.</small>
      </div>
    );
  }

  // Centre sur la moyenne des coords ou Conakry par défaut
  const centreDefault = [9.537, -13.677];
  const centre = avecGps.length > 0
    ? [
        avecGps.reduce((s, a) => s + parseFloat(a.latitude), 0) / avecGps.length,
        avecGps.reduce((s, a) => s + parseFloat(a.longitude), 0) / avecGps.length,
      ]
    : centreDefault;

  return (
    <div className="map-wrapper">
      <div className="map-legende">
        {Object.entries(COULEURS).map(([type, couleur]) => (
          <span key={type} className="map-legende-item">
            <span className="map-legende-dot" style={{ background: couleur }} />
            {LABELS[type]}
          </span>
        ))}
        <span className="map-legende-count">{avecGps.length} annonce{avecGps.length > 1 ? 's' : ''} sur la carte</span>
      </div>

      <MapContainer
        center={centre}
        zoom={12}
        className="map-container"
        scrollWheelZoom={true}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />

        {avecGps.map(a => (
          <Marker
            key={a._id}
            position={[parseFloat(a.latitude), parseFloat(a.longitude)]}
            icon={creerIcone(a.type)}
          >
            <Popup className="map-popup-wrap" maxWidth={240}>
              <div className="map-popup">
                {a.photos?.[0]?.url && (
                  <img src={a.photos[0].url} alt={a.titre} className="map-popup-img" />
                )}
                <div className="map-popup-body">
                  <span className="map-popup-type" style={{ background: COULEURS[a.type] }}>
                    {LABELS[a.type]}
                  </span>
                  <p className="map-popup-titre">{a.titre}</p>
                  <p className="map-popup-prix">{fmt(a.prix)}{a.type === 'location' && <span>{locationPriceSuffix(a)}</span>}</p>
                  <p className="map-popup-loc">
                    {a.quartier}{a.commune ? `, ${a.commune}` : ''} — {a.ville}
                  </p>
                  <Link to={`/annonce/${a._id}`} className="map-popup-btn">
                    Voir l'annonce →
                  </Link>
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
